import { render, staticRenderFns } from "./LpContactsDetails.vue?vue&type=template&id=13dcd043"
import script from "./LpContactsDetails.vue?vue&type=script&lang=js"
export * from "./LpContactsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports